export default "__VITE_ASSET__e252233c__"